// import { API, APIFORMDATA } from '../../api/apiutils';
import { API,APIFORMDATA } from '../middlewares/APIUtils.tsx';

export const uploadDocumentAPIHelper = async (formData: FormData) => {
  try {
    const response = await APIFORMDATA.post('/api/documents/upload', formData);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getUserDocumentsAPIHelper = async (userId: string | number) => {
  try {
    const response = await API.get(`/api/documents/user/${userId}`);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};



export const deleteDocumentAPIHelper = async (userId: number, docId: string | number) => {
    
    const response = await API.delete(`/api/documents/user/${userId}/${docId}`);
    return response.data;
};

export const deleteAllDocumentsAPIHelper = async (userId: number) => {
    // Hits: DELETE /api/documents/user/:userId
    const response = await API.delete(`/api/documents/user/${userId}`);
    return response.data;
};